import {
  DescriptionPage_SelfServeConfiguration_KeyInfoModule_ItemName as KeyInfoModuleItemName,
  DescriptionPage_SelfServeConfiguration_ModuleName as SelfServeConfigurationModuleNames,
} from '__generated__/graphql-types';

import type {
  SelfServeConfigProductOverviewModuleFragment,
  SelfServeConfigurationFragment,
} from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerSpecializationMarketingPageQuery';

export const ProductDetailItemNames = {
  ShareableCertificate: 'ShareableCertificate',
  Languages: 'Languages',
  IndustryCertification: 'IndustryCertification',
  RecentlyUpdated: 'RecentlyUpdated',
  ShareableCaseStudy: 'ShareableCaseStudy',
  Exclusive: 'Exclusive',
  SyllabusContent: 'SyllabusContent',
  LanguagesWithMLInfo: 'LanguagesWithMLInfo',
  InstallationRequirements: 'InstallationRequirements',
  Stackability: 'Stackability',
} as const;

export const UpsellCardNames = {
  CourseraPlusUpsellCard: 'CourseraPlusUpsellCard',
  DegreeUpsellCard: 'DegreeUpsellCard',
  EnterpriseUpsellCard: 'EnterpriseUpsellCard',
} as const;

export const KeyInformationItemNames = {
  ...KeyInfoModuleItemName,
  ModuleCount: 'ModuleCount',
  DegreePathway: 'DegreePathway',
  InstallationRequirements: 'InstallationRequirements',
  LearningMethod: 'LearningMethod',
  CourseSatisfactionScore: 'CourseSatisfactionScore',
  ProductType: 'ProductType',
  EarnCertificate: 'EarnCertificate',
} as const;

export type KeyInformationItemConfig = {
  name: (typeof KeyInformationItemNames)[keyof typeof KeyInformationItemNames];
  title?: string | null;
  subtitle?: string | null;
};

export type KeyInfoModule = {
  items?: KeyInformationItemConfig[];
};

export type ProductOverviewModuleConfig = Omit<
  SelfServeConfigProductOverviewModuleFragment,
  'heroModule' | 'keyInfoModule'
> & {
  heroModule?: SelfServeConfigProductOverviewModuleFragment['heroModule'] & { backgroundColor?: string };
  keyInfoModule?: SelfServeConfigProductOverviewModuleFragment['keyInfoModule'] & KeyInfoModule;
  removeLinksAboveFold?: boolean;
  showHeroLanguageInfo?: boolean;
  // Assign button only shows up for Admin users which takes them to the program’s assign flow
  showAssignButton?: boolean;
  hideCourseraPlus?: boolean;
  hideInstructors?: boolean;
  showBackgroundImage?: boolean;
  productDetailItems: Array<(typeof ProductDetailItemNames)[keyof typeof ProductDetailItemNames]>;
  backgroundImage?: string;
};

export const ModuleNames = {
  ...SelfServeConfigurationModuleNames,
  ProjectInstructions: 'ProjectInstructions',
  Reviews: 'Reviews',
  Recommendations: 'Recommendations',
  Benefits: 'Benefits',
  RegionalPromotionBanner: 'RegionalPromotionBanner',
  DiscoveryRecommendations: 'DiscoveryRecommendations',
  CourseraPlusRecommendations: 'CourseraPlusRecommendations',
  AiDisclaimer: 'AiDisclaimer',
} as const;

export type ModuleName = (typeof ModuleNames)[keyof typeof ModuleNames];

export type PageConfig = Omit<SelfServeConfigurationFragment, 'modules'> & {
  modules: Array<
    | SelfServeConfigurationFragment['modules'][number]
    | {
        name: (typeof ModuleNames)[keyof typeof ModuleNames];
      }
  >;
};
